import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import Terms from '../views/Terms'
import Policy from '../views/Policy'
import Login from '../views/Login'
import Dashboard from '../views/Dashboard'
import store from '../vuex/store'
import CompanyList from '../views/user_management/company/CompanyList'
import CompanyDetail from '../views/user_management/company/CompanyDetail'
import DepartmentList from '../views/user_management/department/DepartmentList'
import DepartmentDetail from '../views/user_management/department/DepartmentDetail'
import PackageList from '../views/user_management/package/PackageList'
import PackageDetail from '../views/user_management/package/PackageDetail'
import ParamList from '../views/user_management/param/ParamList'
import ParamDetail from '../views/user_management/param/ParamDetail'
import RoleDetail from '../views/user_management/role/RoleDetail'
import RoleList from '../views/user_management/role/RoleList'
import PermissionDetail from '../views/user_management/permission/PermissionDetail'
import PermissionList from '../views/user_management/permission/PermissionList'
import UserDetail from '../views/user_management/user/UserDetail'
import UserList from '../views/user_management/user/UserList'
import Marketing from '../views/user_management/marketing/Marketing'
import AdminDetail from '../views/user_management/user-admin/AdminDetail'
import AdminList from '../views/user_management/user-admin/AdminList'
import ProductDetail from '../views/product/product/ProductDetail'
import ProductList from '../views/product/product/ProductList'
import Page404 from '../views/Page404'
import Page500 from '../views/Page500'
import General from '../views/user_management/General'
import * as types from '../vuex/mutation-types'
import ExtUserManagement from '../views/call_center/ExtUserManagement'
import CallRecords from '../views/call_center/CallRecords'
import CallReport from '../views/call_center/CallReport'
import CallCenterIntro from '../views/call_center/CallCenterIntro'
import OrderList from '../views/order_management/OrderList'
import CdrReport from '../views/call_center/CdrReport'
import CallCenterListManagement from '../views/call_center/CallCenterListManagement'
import FacebookConnect from '../views/social_network/FacebookConnect'
import ZaloConnect from '../views/social_network/ZaloConnect'
import OrderDetail from '../views/order_management/OrderDetail'
import OrderAddOrEdit from '../views/order_management/OrderAddOrEdit'
import DataStatus from '../views/setting/DataStatus'
import DataSubStatus from '../views/setting/DataSubStatus'
import SettingBoard from '../views/setting/SettingBoard'
import DataSource from '../views/setting/DataSource'
import DataChannel from '../views/setting/DataChannel'
import EmailTemplate from '../views/setting/EmailTemplate'
import CompanyEmail from '../views/setting/CompanyEmail'
import ReportNewOrder from '../views/report/ReportNewOrder'
import ReportAnnualRevenue from '../views/report/ReportAnnualRevenue'
import CompanyLogo from '../views/setting/CompanyLogo'
import AccountingList from '../views/accounting/AccountingList'
import AccountingDetailList from '../views/accounting/AccountingDetailList'
import ReportBadDebt from '../views/report/ReportBadDebt'
import ImportOrder from '../views/order_management/ImportOrder'
import ImportOrderData from '../views/order_management/ImportOrderData'
import ReportOrderStatus from '../views/report/ReportOrderStatus'
import Package from '../views/setting/Package'
import PhoneNumberSettings from '../views/phone_number/PhoneNumberSettings.vue'
import MainPhoneNumber from '../views/phone_number/MainPhoneNumber.vue'
import PhoneNumberClient from '../views/phone_number/PhoneNumberClient.vue'
import PhoneNumberStatus from '../views/phone_number/PhoneNumberStatus.vue'
import Provider from '../views/phone_number/Provider.vue'
import Legal from '../views/phone_number/Legal.vue'
import ImportPhoneNumber from '../views/phone_number_management/import_phone_number/ImportPhoneNumber.vue'
import PhoneNumberManagementList from '../views/phone_number_management/PhoneNumberManagementList.vue'
import PhoneNumberForTechList from '../views/phone_number_management/techical_list/PhoneNumberForTechList.vue'

Vue.use(Router)

const routes = [
  {path: '/404', name: 'Page404', component: Page404},
  {path: '/500', name: 'Page500', component: Page500},
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/terms',
    name: 'Terms',
    component: Terms,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/policy',
    name: 'Policy',
    component: Policy,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/company/general',
    name: 'CompanyGeneral',
    component: General,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/company',
    name: 'CompanyList',
    component: CompanyList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/company/add',
    name: 'CompanyAdd',
    component: CompanyDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/company/edit/:id',
    name: 'CompanyEdit',
    component: CompanyDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/department',
    name: 'DepartmentList',
    component: DepartmentList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/department/add',
    name: 'DepartmentAdd',
    component: DepartmentDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/department/edit/:id',
    name: 'DepartmentEdit',
    component: DepartmentDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/package',
    name: 'PackageList',
    component: PackageList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/package/add',
    name: 'PackageAdd',
    component: PackageDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/package/edit/:id',
    name: 'PackageEdit',
    component: PackageDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/param',
    name: 'ParamList',
    component: ParamList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/param/add',
    name: 'ParamAdd',
    component: ParamDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/param/edit/:id',
    name: 'ParamEdit',
    component: ParamDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/role',
    name: 'RoleList',
    component: RoleList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/role/add',
    name: 'RoleAdd',
    component: RoleDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/role/edit/:id',
    name: 'RoleEdit',
    component: RoleDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/permission',
    name: 'PermissionList',
    component: PermissionList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/permission/add',
    name: 'PermissionAdd',
    component: PermissionDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/permission/edit/:id',
    name: 'PermissionEdit',
    component: PermissionDetail,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/user',
    name: 'UserList',
    component: UserList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/user/add',
    name: 'UserAdd',
    component: UserDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/user/edit/:id',
    name: 'UserEdit',
    component: UserDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin',
    name: 'AdminList',
    component: AdminList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin/add',
    name: 'AdminDetail',
    component: AdminDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin/edit/:id',
    name: 'AdminEdit',
    component: AdminDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/marketing',
    name: 'Marketing',
    component: Marketing,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/product',
    name: 'ProductList',
    component: ProductList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/product/add',
    name: 'ProductAdd',
    component: ProductDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/product/edit/:id',
    name: 'ProductEdit',
    component: ProductDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/ext-management',
    name: 'ExtUserManagement',
    component: ExtUserManagement,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/call-center/records',
    name: 'CallRecords',
    component: CallRecords,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/call-center/report',
    name: 'CallReport',
    component: CallReport,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/call-center/cdr-report',
    name: 'CdrReport',
    component: CdrReport,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/call-center/about',
    name: 'CallCenterIntro',
    component: CallCenterIntro,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/accounting/list',
    name: 'AccountingList',
    component: AccountingList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/phone-numbers',
    name: 'PhoneNumberManagementList',
    component: PhoneNumberManagementList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/import-phone-numbers',
    name: 'ImportPhoneNumber',
    component: ImportPhoneNumber,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/phone-number-technical',
    name: 'PhoneNumberForTechList',
    component: PhoneNumberForTechList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/accounting_detail/list',
    name: 'AccountingDetailList',
    component: AccountingDetailList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/order/list',
    name: 'OrderList',
    component: OrderList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/order/import',
    name: 'ImportOrder',
    component: ImportOrder,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/order/import_data',
    name: 'ImportOrderData',
    component: ImportOrderData,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/order/add',
    name: 'OrderAdd',
    component: OrderAddOrEdit,
    meta: {
      requiresAuth: true
    }

  },
  {
    path: '/order/detail/:id',
    name: 'OrderDetail',
    component: OrderDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/order/edit/:id',
    name: 'OrderAdd',
    component: OrderAddOrEdit,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/phone-number/import',
    name: 'ImportPhoneNumber',
    component: ImportPhoneNumber,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/call-center/list',
    name: 'CallCenterListManagement',
    component: CallCenterListManagement,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/sync/facebook',
    name: 'FacebookConnect',
    component: FacebookConnect,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/sync/zalo',
    name: 'ZaloConnect',
    component: ZaloConnect,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings',
    name: 'SettingBoard',
    component: SettingBoard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/data-source',
    name: 'DataSource',
    component: DataSource,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/data-source/sub/:id',
    name: 'DataChannel',
    component: DataChannel,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/email-template',
    name: 'EmailTemplate',
    component: EmailTemplate,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/company-email',
    name: 'CompanyEmail',
    component: CompanyEmail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/company-logo',
    name: 'CompanyLogo',
    component: CompanyLogo,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/data-status',
    name: 'DataStatus',
    component: DataStatus,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/data-status/sub/:id',
    name: 'DataSubStatus',
    component: DataSubStatus,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/package',
    name: 'Package',
    component: Package,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/report/new-order',
    name: 'ReportNewOrder',
    component: ReportNewOrder,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/report/annual-revenue',
    name: 'ReportAnnualRevenue',
    component: ReportAnnualRevenue,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/report/bad-debt',
    name: 'ReportBadDebt',
    component: ReportBadDebt,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/report/order-status',
    name: 'ReportOrderStatus',
    component: ReportOrderStatus,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/phone-number/settings',
    name: 'PhoneNumberSettings',
    component: PhoneNumberSettings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/phone-number/main-phone-number',
    name: 'MainPhoneNumber',
    component: MainPhoneNumber,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/phone-number/phone-number-client',
    name: 'PhoneNumberClient',
    component: PhoneNumberClient,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/phone-number/status',
    name: 'PhoneNumberStatus',
    component: PhoneNumberStatus,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/phone-number/provider',
    name: 'PhoneNumberProvider',
    component: Provider,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/phone-number/legal',
    name: 'PhoneNumberLegal',
    component: Legal,
    meta: {
      requiresAuth: true
    }
  }
]

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({y: 0}),
  routes: routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (to.path !== '/login' && store.getters.currentUser.user_info === null) {
      next({name: 'Login'})
    } else {
      next()
    }
  } else {
    next()
  }
  store.commit(types.CHANGE_MENU, to.name)
})

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js